import styled from "styled-components";

export const DepositHeaderButtonDefaultBox = styled.div`
    width: 29px;
    height: 19px;
    margin-right: 16px;
    cursor: pointer;
`;